import { render, staticRenderFns } from "./NotificationsDrawer.vue?vue&type=template&id=321bf141&scoped=true&"
import script from "./NotificationsDrawer.vue?vue&type=script&lang=ts&"
export * from "./NotificationsDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsDrawer.vue?vue&type=style&index=0&id=321bf141&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321bf141",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('321bf141', component.options)
    } else {
      api.reload('321bf141', component.options)
    }
    module.hot.accept("./NotificationsDrawer.vue?vue&type=template&id=321bf141&scoped=true&", function () {
      api.rerender('321bf141', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/NotificationsDrawer.vue"
export default component.exports